/**
 * 登录 / 注册页.
 *
 * 表单状态放在页面组件里, 提交动作直接调 $store.auth (认证逻辑集中在 stores/auth.ts).
 */

const PASSWORD_MIN = 8
// 邀请码为 4 位字母+数字, 不区分大小写(提交前统一转大写)
const INVITE_CODE_PATTERN = /^[A-Za-z0-9]{4}$/

export function loginPage() {
  return {
    email: '',
    password: '',

    get canSubmit(): boolean {
      return this.email.includes('@') && this.password.length > 0
    },
  }
}

export function registerPage() {
  return {
    email: '',
    /** 邀请码: 注册采用邀请制, 必填 */
    inviteCode: '',
    password: '',
    confirm: '',

    get passwordMismatch(): boolean {
      return this.confirm.length > 0 && this.password !== this.confirm
    },

    get inviteCodeValid(): boolean {
      return INVITE_CODE_PATTERN.test(this.inviteCode.trim())
    },

    get canSubmit(): boolean {
      return (
        this.email.includes('@') &&
        this.inviteCodeValid &&
        this.password.length >= PASSWORD_MIN &&
        this.password === this.confirm
      )
    },

    get passwordHint(): string {
      return `至少 ${PASSWORD_MIN} 位, 需与确认密码一致`
    },
  }
}
